import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const WelcomePopup = () => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const hasSeenPopup = localStorage.getItem("welcomePopupSeen");
    if (!hasSeenPopup) {
      const timer = setTimeout(() => {
        setShow(true);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, []);

  const closePopup = () => {
    setShow(false);
    localStorage.setItem("welcomePopupSeen", "true");
  };

  const handleOrderNow = () => {
    closePopup();
    navigate("/order-online");
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[9999]">
      <div className="bg-white w-[90%] max-w-sm p-8 rounded-xl text-center relative animate-fade-in-scale">
        <button
          className="absolute top-3 right-3 bg-none border-none text-[30px] text-black cursor-pointer hover:opacity-70"
          onClick={closePopup}
        >
          &times;
        </button>

        <p className="mb-6 text-lg text-black font-['Prata',serif]">
          Welcome to our brand new, easier to use website.
        </p>

        <button
          className="w-full py-3 bg-brand-orange text-black border-none rounded-lg text-base font-bold cursor-pointer hover:opacity-90 font-[inherit]"
          onClick={handleOrderNow}
        >
          Order Now
        </button>
      </div>
    </div>
  );
};

export default WelcomePopup;
